var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"captcha-wrapper"},[_c('div',{key:_vm.captchaKey,attrs:{"id":"captcha-element"}})])}
var staticRenderFns = []

export { render, staticRenderFns }